import axiosBase from '~/utils/axios';

export interface TokenTransferResponse {
  language: string;
  company: {
    id: string;
    name: string;
    dbName: string;
    timeClockingLevels: string[];
    branch: string;
  } | null;
  branch: {
    value: string;
  } | null;
  userId: string;
}

export default class TokenTransferApi {
  public static async getTokensByTransferKey(transferKey: string): Promise<TokenTransferResponse> {
    return axiosBase.get(`/auth/get-tokens/${transferKey}`).then(({ data }) => data);
  }
}
